/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      name
      description
      price
      cost
      sku
      image
      details {
        items {
          id
          productID
          name
          content
          createdAt
          updatedAt
        }
        nextToken
      }
      reviews {
        items {
          id
          productID
          title
          content
          stars
          createdAt
          updatedAt
        }
        nextToken
      }
      transactions {
        items {
          id
          productID
          transactionID
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        price
        cost
        sku
        image
        details {
          nextToken
        }
        reviews {
          nextToken
        }
        transactions {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTransaction = /* GraphQL */ `
  query GetTransaction($id: ID!) {
    getTransaction(id: $id) {
      id
      createdAt
      customerID
      customer {
        id
        userID
        username
        firstname
        middlename
        lastname
        phone
        number
        transactions {
          nextToken
        }
        createdAt
        updatedAt
      }
      total
      subtotal
      shipping
      tax
      products {
        items {
          id
          productID
          transactionID
          createdAt
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const listTransactions = /* GraphQL */ `
  query ListTransactions(
    $filter: ModelTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTransactions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        customerID
        customer {
          id
          userID
          username
          firstname
          middlename
          lastname
          phone
          number
          createdAt
          updatedAt
        }
        total
        subtotal
        shipping
        tax
        products {
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      userID
      username
      firstname
      middlename
      lastname
      phone
      number
      transactions {
        items {
          id
          createdAt
          customerID
          total
          subtotal
          shipping
          tax
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCustomers = /* GraphQL */ `
  query ListCustomers(
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        username
        firstname
        middlename
        lastname
        phone
        number
        transactions {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getInventory = /* GraphQL */ `
  query GetInventory($id: ID!) {
    getInventory(id: $id) {
      id
      productID
      count
      createdAt
      updatedAt
    }
  }
`;
export const listInventories = /* GraphQL */ `
  query ListInventories(
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        productID
        count
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getProductReview = /* GraphQL */ `
  query GetProductReview($id: ID!) {
    getProductReview(id: $id) {
      id
      productID
      title
      content
      stars
      product {
        id
        name
        description
        price
        cost
        sku
        image
        details {
          nextToken
        }
        reviews {
          nextToken
        }
        transactions {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listProductReviews = /* GraphQL */ `
  query ListProductReviews(
    $filter: ModelProductReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductReviews(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        productID
        title
        content
        stars
        product {
          id
          name
          description
          price
          cost
          sku
          image
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getProductDetail = /* GraphQL */ `
  query GetProductDetail($id: ID!) {
    getProductDetail(id: $id) {
      id
      productID
      name
      content
      createdAt
      updatedAt
    }
  }
`;
export const listProductDetails = /* GraphQL */ `
  query ListProductDetails(
    $filter: ModelProductDetailFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductDetails(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        productID
        name
        content
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEmployee = /* GraphQL */ `
  query GetEmployee($id: ID!) {
    getEmployee(id: $id) {
      id
      firstName
      lastName
      createdAt
      updatedAt
    }
  }
`;
export const listEmployees = /* GraphQL */ `
  query ListEmployees(
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployees(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const productBySku = /* GraphQL */ `
  query ProductBySku(
    $sku: String
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productBySku(
      sku: $sku
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        price
        cost
        sku
        image
        details {
          nextToken
        }
        reviews {
          nextToken
        }
        transactions {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const customerByUserID = /* GraphQL */ `
  query CustomerByUserID(
    $userID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerByUserID(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        username
        firstname
        middlename
        lastname
        phone
        number
        transactions {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
